import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface OrgSettings {
  id: string;
  name: string;
  slug: string;
  timezone: string;
  cnpj: string | null;
  phone: string | null;
  whatsapp: string | null;
  email: string | null;
  instagram: string | null;
  facebook: string | null;
  tiktok: string | null;
  brandPrimary: string;
  brandAccent: string;
  logoAssetId: string | null;
  faviconAssetId: string | null;
}

export interface Branch {
  id: string;
  name: string;
  phone: string | null;
  active: boolean;
  address: { cep: string; state: string; city: string; district: string; street: string; number: string; complement: string | null };
}

export interface BarberSummary {
  id: string;
  displayName: string;
  branchId: string;
  color: string;
  active: boolean;
  photoAssetId: string | null;
  serviceIds: string[];
}

export const useOrgSettings = () => useQuery({ queryKey: ['org', 'settings'], queryFn: () => api.get<OrgSettings>('/org/settings'), staleTime: 300_000 });
export const useBranches = () => useQuery({ queryKey: ['org', 'branches'], queryFn: () => api.get<Branch[]>('/org/branches'), staleTime: 300_000 });
export const useBarbers = () => useQuery({ queryKey: ['barbers', 'active'], queryFn: () => api.get<BarberSummary[]>('/barbers'), staleTime: 60_000 });

/** Fuso horário da barbearia ativa (padrão São Paulo). */
export function useTimezone() {
  return useOrgSettings().data?.timezone ?? 'America/Sao_Paulo';
}
